module.exports = __webpack_public_path__ + "public/img/bg_03.49645dc7.png";